import { useEffect, useRef, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

let googleScriptPromise;

function loadGoogleIdentityServices() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (!googleScriptPromise) {
    googleScriptPromise = new Promise((resolve, reject) => {
      const script = document.getElementById("google-identity-services");
      if (script) {
        script.addEventListener("load", resolve, { once: true });
        script.addEventListener("error", reject, { once: true });
        return;
      }
      const newScript = document.createElement("script");
      newScript.id = "google-identity-services";
      newScript.src = "https://accounts.google.com/gsi/client";
      newScript.async = true;
      newScript.defer = true;
      newScript.onload = resolve;
      newScript.onerror = reject;
      document.head.appendChild(newScript);
    });
  }
  return googleScriptPromise;
}

export default function GoogleSignInButton({ onCredential, disabled = false }) {
  const containerRef = useRef(null);
  const onCredentialRef = useRef(onCredential);
  const [error, setError] = useState("");

  useEffect(() => {
    onCredentialRef.current = onCredential;
  }, [onCredential]);

  useEffect(() => {
    let mounted = true;
    const renderButton = async () => {
      try {
        const { data } = await api.get("/auth/google/config");
        if (!mounted) return;
        if (!data.enabled || !data.client_id) {
          setError("تسجيل الدخول عبر Google غير مهيأ حالياً.");
          return;
        }
        await loadGoogleIdentityServices();
        if (!mounted || !containerRef.current) return;
        window.google.accounts.id.initialize({
          client_id: data.client_id,
          callback: (response) => {
            if (response.credential) onCredentialRef.current(response.credential);
          },
          auto_select: false,
        });
        window.google.accounts.id.renderButton(containerRef.current, {
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "pill",
          width: Math.min(containerRef.current.clientWidth || 400, 400),
          locale: "ar",
        });
      } catch (requestError) {
        if (mounted) {
          setError(formatApiErrorDetail(requestError.response?.data?.detail) || "تعذر تحميل تسجيل الدخول عبر Google.");
        }
      }
    };
    renderButton();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="mt-5">
      <div className="mb-4 flex items-center gap-3 text-[11px] font-semibold text-muted-foreground">
        <span className="h-px flex-1 bg-border" />
        أو تابع باستخدام
        <span className="h-px flex-1 bg-border" />
      </div>
      <div className={disabled ? "pointer-events-none opacity-50" : ""}>
        <div ref={containerRef} className="flex min-h-10 justify-center" />
      </div>
      {error && <p role="status" className="mt-2 text-center text-xs text-destructive">{error}</p>}
    </div>
  );
}
